import { useEffect } from "react";

// This hook detects clicks outside of the specified component and calls the provided handler function.
export default function useOnClickOutside(ref, handler) {
    useEffect(() => {
        // Define the listener function to be called on click/touch events
        const listener = (e) => {
            if (!ref.current || ref.current.contain(e.target)) {
                return;
            }
            // otherwise call the handler function
            handler(e);
            // Add event listeners for mousedown and touchstart events on the document
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);

            // Cleanup function to remove the event listeners when the component unmounts or when the ref/handler dependencies change
            return () => {
                document.removeEventListener("mousedown", listener);
                document.removeEventListener("touchstart", listener);
            };
        };
    }, [ref, handler]);
};